module.exports = __webpack_public_path__ + "static/media/data-logs.796e4f10.png";